import { Bars3Icon } from '@heroicons/react/24/outline';
import { Button } from 'antd';
import React from 'react';
// import { useLocation } from 'react-router-dom';

interface NavbarProps {
  isMobile: boolean;
  onMenuClick: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ isMobile, onMenuClick }) => {
  // const location = useLocation();

  return (
    <div className="!px-5 py-13 bg-[#fff] flex items-center justify-between h-full">
      {isMobile && (
        <Button type="text" icon={<Bars3Icon className="w-6 text-black" />} onClick={onMenuClick} />
      )}

      {/* <Typography.Title level={5} style={{ margin: 0 }}>
        {location.pathname.split('/').pop()?.toUpperCase() || 'DASHBOARD'}
      </Typography.Title> */}

      <div className="flex flex-col leading-tight">
        <span className="font-heading text-[24px]  font-semibold text-[#fc4c02] ">GlassWalk</span>
        <span className="text-sm text-[#222222] font-heading">
          Into the world of Glass Packaging
        </span>
      </div>

      {/* Improved Powered by Section */}
      <span className="flex flex-col leading-tight">
        <img src="/factoryViewAR.png" alt="Powered by Innovate Labs" width={150} />
        <span className="text-sm text-[#222222]  font-heading"> By Innovate Labs</span>
      </span>
    </div>
  );
};

export default Navbar;
